"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default(theme, props, state) {
  var _theme = theme,
      palette = _theme.palette;
  theme = _objectSpread({}, theme, {
    color: theme.idleColor,
    placeholder: theme.idlePlaceholder,
    labelColor: theme.idleLabelColor,
    borderColor: theme.idleBorderColor,
    borderStyle: theme.idleBorderStyle,
    borderWidth: theme.idleBorderWidth,
    borderTransform: theme.idleBorderTransform,
    borderRadius: theme.idleBorderRadius,
    background: theme.idleBackground
  });

  if (state.hover) {
    theme = _objectSpread({}, theme, {
      color: theme.hoverColor,
      placeholder: theme.hoverPlaceholder,
      labelColor: theme.hoverLabelColor,
      borderColor: theme.hoverBorderColor,
      borderStyle: theme.hoverBorderStyle,
      borderWidth: theme.hoverBorderWidth,
      borderTransform: theme.hoverBorderTransform,
      borderRadius: theme.hoverBorderRadius,
      background: theme.hoverBackground
    });
  }

  if (state.focus) {
    theme = _objectSpread({}, theme, {
      color: theme.focusColor,
      placeholder: theme.focusPlaceholder,
      labelColor: props.error ? theme.errorLabelColor : theme.focusLabelColor,
      borderColor: theme.focusBorderColor,
      borderStyle: theme.focusBorderStyle,
      borderWidth: theme.focusBorderWidth,
      borderTransform: theme.focusBorderTransform,
      borderRadius: theme.focusBorderRadius,
      background: theme.focusBackground
    });
  }

  if (props.error) {
    theme = _objectSpread({}, theme, {
      color: theme.errorColor,
      placeholder: theme.errorPlaceholder,
      borderColor: theme.errorBorderColor,
      borderStyle: theme.errorBorderStyle,
      borderWidth: theme.errorBorderWidth,
      borderTransform: theme.errorBorderTransform,
      borderRadius: theme.errorBorderRadius,
      background: theme.errorBackground
    });
  }

  if (props.disabled) {
    theme = _objectSpread({}, theme, {
      color: theme.disabledColor,
      placeholder: theme.disabledPlaceholder,
      labelColor: theme.disabledLabelColor,
      borderStyle: theme.disabledBorderStyle,
      borderColor: theme.disabledBorderColor,
      borderWidth: theme.disabledBorderWidth,
      borderTransform: theme.disabledBorderTransform,
      borderRadius: theme.disabledBorderRadius,
      background: theme.disabledBackground
    });
  }

  var rawLabelFontSize = theme.labelFontSize,
      rawLabelLineHeight = theme.labelLineHeight;
  theme.labelFontSize = theme.fontSize;
  theme.labelLineHeight = theme.lineHeight; // label is not floats

  if (!props.floating || state.focus || !!props.value || !!props.defaultValue) {
    var fontSize = (0, _pixelToNumber["default"])(theme.fontSize);
    theme.labelTransform = "scale(".concat((0, _pixelToNumber["default"])(rawLabelFontSize) / fontSize, ") translate3d(0px, 0px, 0px)"); // label floats and increase size relative to lineHeight
  } else {
    var paddingTop = (0, _pixelToNumber["default"])(theme.paddingTop);
    theme.labelTransform = "translateY(".concat((0, _pixelToNumber["default"])(rawLabelLineHeight) + paddingTop, "px) scale(1)");
    theme.labelPaddingLeft = theme.paddingLeft;
    theme.labelPaddingRight = theme.paddingRight;
    theme.labelOverflow = 'hidden';
  }

  var cropLabelStyles = {};

  if (props.cropLabel) {
    cropLabelStyles = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    };
  } // рамка со всех сторон, классический инпут
  // скрываем нижнюю границу, применяем стиль к инпуту напрямую


  var wrappedBorder = !/none/.test(theme.borderStyle),
      passiveBorderOpacity = wrappedBorder || props.disabled ? 0 : 1,
      activeBorderOpacity = wrappedBorder ? 0 : 1,
      fieldBorder = {},
      scrollStyle = {};

  if (wrappedBorder) {
    fieldBorder = {
      borderStyle: theme.borderStyle,
      borderColor: theme.borderColor,
      borderWidth: theme.borderWidth,
      borderRadius: theme.borderRadius
    };
  }

  if (window && /WebKit/i.test(window.navigator.userAgent)) {
    scrollStyle = {
      '&::-webkit-scrollbar': {
        width: palette.gutter / 2 + 'px'
      },
      '&::-webkit-scrollbar-button': {
        display: 'none'
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        background: palette.elDivider,
        borderRadius: '100px',
        transition: "background ".concat(palette.transitionDuration, " ").concat(palette.transitionFunction),
        '&:hover': {
          background: palette.elDarkest
        }
      },
      '&::-webkit-scrollbar-corner': {
        display: 'none'
      },
      '&::-webkit-resizer': {
        display: 'none'
      }
    };
  } // for resizing


  this.lineHeight = (0, _pixelToNumber["default"])(theme.fontSize) * theme.lineHeight; // this.paddingHeight = pixelToNumber(theme.paddingTop) + pixelToNumber(theme.paddingBottom);

  return {
    root: {
      display: theme.display,
      verticalAlign: theme.verticalAlign,
      width: theme.width,
      minWidth: theme.minWidth
    },
    wrapper: {
      position: 'relative',
      font: "".concat(palette.tsNormal, "/").concat(palette.tlNormal, " \"").concat(theme.fontFamily, "\""),
      zoom: 1
    },
    label: _objectSpread({
      color: theme.labelColor,
      fontSize: theme.labelFontSize,
      lineHeight: theme.labelLineHeight,
      fontFamily: theme.fontFamily,
      position: 'absolute',
      top: 0,
      left: 0,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: 'ease',
      transitionProperty: 'color, transform',
      transform: theme.labelTransform,
      transformOrigin: '0% 0%',
      textWrap: 'none',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
      width: '100%',
      overflow: theme.labelOverflow,
      textAlign: theme.textAlign,
      paddingTop: '0',
      paddingRight: theme.labelPaddingRight,
      paddingBottom: '0',
      paddingLeft: theme.labelPaddingLeft
    }, cropLabelStyles),
    labelHolder: {
      fontSize: rawLabelFontSize,
      lineHeight: rawLabelLineHeight
    },
    input: _objectSpread({
      position: 'relative',
      background: theme.background,
      margin: 0,
      paddingTop: theme.paddingTop,
      paddingRight: theme.paddingRight,
      paddingBottom: theme.paddingBottom,
      paddingLeft: theme.paddingLeft
    }, fieldBorder),
    field: _objectSpread({
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      color: theme.color,
      maxWidth: '100%',
      padding: 0,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'transform, color',
      margin: 0,
      // make custom scroll
      // overflow: 'hidden',
      textAlign: 'left',
      border: '0 none',
      resize: 'none',
      background: 'transparent',
      width: '100%',
      verticalAlign: 'top'
    }, scrollStyle, {
      '&::placeholder': {
        color: theme.placeholder,
        transitionDuration: palette.transitionDuration,
        transitionTimingFunction: palette.transitionFunction,
        transitionProperty: 'transform, color'
      },
      '&:focus, &:active': {
        outline: 'none'
      }
    }),
    shadow: {
      visibility: 'hidden',
      position: 'absolute',
      zIndex: -1,
      top: 0,
      left: 0,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight,
      padding: 0,
      margin: 0,
      border: 'none',
      resize: 'none',
      outline: 'none',
      overflow: 'hidden',
      width: '100%',
      verticalAlign: 'top'
    },
    fieldWrapper: {
      position: 'relative'
    },
    border: {
      borderImage: 'none',
      borderStyle: 'none none solid',
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      width: '100%',
      position: 'absolute',
      bottom: 0,
      borderColor: theme.idleBorderColor,
      borderWidth: "medium medium ".concat(theme.idleBorderWidth),
      opacity: passiveBorderOpacity
    },
    activeBorder: {
      borderImage: 'none',
      borderStyle: theme.borderStyle,
      borderWidth: "medium medium ".concat(theme.borderWidth),
      boxSizing: 'content-box',
      height: 0,
      margin: 0,
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      transitionProperty: 'opacity, transform, border',
      width: '100%',
      position: 'absolute',
      bottom: 0,
      borderColor: theme.borderColor,
      transform: theme.borderTransform,
      opacity: activeBorderOpacity
    }
  };
}